(() => {
  const T = (k) => (window.KurlectiveI18n || {})[k] || '';
  const KROOT = window.Shopify?.routes?.root || '/';
  const localPath = (path = '') => KROOT + String(path).replace(/^\/+/, '');
  const ensureDiscoverStyles = () => {
    if (document.getElementById('k-discover-entry-styles')) return;
    const style = document.createElement('style');
    style.id = 'k-discover-entry-styles';
    style.textContent = `
      .k-nav .k-needs-primary span{font-size:10px!important;line-height:1.15!important}
      .drawer-discover-link{min-height:64px;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:0 18px;border-bottom:1px solid var(--ink);background:var(--signal);color:#fff!important;text-decoration:none;box-shadow:none}
      .drawer-discover-link span{display:flex;flex-direction:column;gap:4px}.drawer-discover-link strong{font-size:16px;line-height:1}.drawer-discover-link small{font-size:10px;color:rgba(255,255,255,.88);line-height:1.2}.drawer-discover-link b{font-size:22px;font-weight:500;color:#fff}
      .home-discover-cta{position:absolute;z-index:12;right:calc(41% + 34px);bottom:34px;min-height:44px;display:inline-flex;align-items:center;gap:8px;padding:0 3px;background:transparent;color:#fff!important;border:0;border-bottom:1px solid rgba(255,255,255,.72);box-shadow:none;font:650 10px/1 var(--font-ui,monospace);text-decoration:none;text-shadow:0 1px 14px rgba(0,0,0,.35)}
      .home-discover-cta b{font-size:15px;font-weight:500}
      .home-discover-cta:hover,.home-discover-cta:focus-visible{background:transparent;color:#fff!important;border-bottom-color:var(--signal)}
      @media(max-width:1050px){.home-discover-cta{right:24px;bottom:calc(480px + 24px)}}
      @media(max-width:760px){
        .k-nav .k-needs-primary span{font-size:8px!important}
        .home-discover-cta{right:18px;bottom:calc(560px + 22px);min-height:44px;padding:0 2px;font-size:9px}
      }
    `;
    document.head.appendChild(style);
  };

  const roots = document.querySelectorAll('[data-k-header]');
  roots.forEach((root) => {
    if (root.dataset.kReady === 'true') return;
    root.dataset.kReady = 'true';
    ensureDiscoverStyles();

    const previewLocation = new URL(window.location.href);
    const previewTheme = previewLocation.searchParams.get('preview_theme_id');
    const isThemePreview = Boolean(
      previewTheme ||
      previewLocation.searchParams.get('preview_key') ||
      previewLocation.searchParams.get('preview_token') ||
      previewLocation.hostname.endsWith('.shopifypreview.com')
    );
    // Shopify's explicit country deep links are needed when a theme preview
    // keeps the original country despite rendering a different market locale.
    const previewCountry = isThemePreview ? previewLocation.searchParams.get('country')?.toUpperCase() : null;
    const activePreviewCountry = ['GB', 'DE', 'US'].includes(previewCountry) ? previewCountry : null;
    const marketPathCountry = (path) => {
      if (/^\/de-de(?:\/|$)/i.test(path)) return 'DE';
      if (/^\/en-us(?:\/|$)/i.test(path)) return 'US';
      return null;
    };
    const keepPreviewContext = (url) => {
      if (!isThemePreview || url.origin !== window.location.origin) return url;
      for (const key of ['preview_theme_id', 'preview_key', 'preview_token']) {
        const value = previewLocation.searchParams.get(key);
        if (value) url.searchParams.set(key, value);
      }
      const specificMarket = marketPathCountry(url.pathname);
      if (activePreviewCountry && (!specificMarket || specificMarket === activePreviewCountry)) {
        url.searchParams.set('country', activePreviewCountry);
      }
      return url;
    };
    const canonicalHref = (target) => {
      const source = String(target || '');
      const localizedTarget = source.startsWith('/') ? localPath(source) : source;
      const url = keepPreviewContext(new URL(localizedTarget, window.location.origin));
      return `${url.pathname}${url.search}${url.hash}`;
    };


    /* Primary CTA label, route and colour state are owned by kurlective-header-cta-toggle.liquid. */

    /* Discover is available via the homepage inspiration CTA and footer; no extra drawer promotion. */
    /* Preview links keep both the selected Shopify country and draft-theme
       context, so subsequent navigation cannot silently reset to GB. */
    if (isThemePreview) {
      const enrichPreviewLink = (link) => {
        if (!(link instanceof HTMLAnchorElement) || !link.hasAttribute('href')) return;
        const href = link.getAttribute('href');
        if (!href || href.startsWith('//') || href.startsWith('#')) return;
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        keepPreviewContext(url);
        link.href = `${url.pathname}${url.search}${url.hash}`;
      };
      document.querySelectorAll('a[href^="/"]').forEach(enrichPreviewLink);
      // Some Moment links are created after initialization when the carousel moves.
      document.addEventListener('click', (event) => {
        const el = event.target instanceof Element ? event.target.closest('a[href]') : null;
        if (el) enrichPreviewLink(el);
      }, true);
    }

    const mega = root.querySelector('[data-k-mega]');
    const megaBackdrop = root.querySelector('[data-k-mega-backdrop]');
    let openTimer; let closeTimer;
    const openMega = (panel) => {
      if (!mega || window.innerWidth <= 760) return;
      window.clearTimeout(closeTimer);
      mega.querySelectorAll('[data-mega-panel]').forEach((node) => node.classList.toggle('active', node.dataset.megaPanel === panel));
      root.querySelectorAll('[data-k-mega-target]').forEach((node) => node.classList.toggle('mega-active', node.dataset.kMegaTarget === panel));
      mega.classList.add('open'); megaBackdrop?.classList.add('open'); mega.setAttribute('aria-hidden','false');
    };
    const closeMega = () => {
      window.clearTimeout(openTimer); mega?.classList.remove('open'); megaBackdrop?.classList.remove('open'); mega?.setAttribute('aria-hidden','true');
      root.querySelectorAll('[data-k-mega-target]').forEach((node) => node.classList.remove('mega-active'));
    };
    const scheduleClose = () => { window.clearTimeout(closeTimer); closeTimer = window.setTimeout(closeMega,170); };
    root.querySelectorAll('[data-k-mega-target]').forEach((link) => {
      link.addEventListener('mouseenter', () => { window.clearTimeout(openTimer); window.clearTimeout(closeTimer); openTimer = window.setTimeout(() => openMega(link.dataset.kMegaTarget),90); });
      link.addEventListener('mouseleave',scheduleClose); link.addEventListener('focus',() => openMega(link.dataset.kMegaTarget));
    });
    mega?.addEventListener('mouseenter',() => window.clearTimeout(closeTimer)); mega?.addEventListener('mouseleave',scheduleClose); mega?.addEventListener('click',() => window.setTimeout(closeMega,0));
    const megaTriggers = [...root.querySelectorAll('[data-k-mega-target]')];
    const inMegaZone = (node) => node instanceof Node && (mega?.contains(node) || megaTriggers.some((trigger) => trigger.contains(node)));
    root.addEventListener('focusout', (event) => {
      if (event.relatedTarget === null && mega?.matches(':hover')) return;
      if (!inMegaZone(event.relatedTarget)) closeMega();
    });
    megaTriggers.forEach((trigger) => trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' || !mega?.classList.contains('open')) return;
      event.preventDefault();
      mega.querySelector('[data-mega-panel].active a')?.focus();
    }));

    const drawer = root.querySelector('[data-k-drawer]');
    const drawerBackdrop = root.querySelector('[data-k-drawer-backdrop]');
    const drawerOpen = root.querySelector('[data-k-drawer-open]');
    const setDrawer = (open) => {
      const hadFocus = drawer?.contains(document.activeElement);
      drawer?.classList.toggle('open',open); drawerBackdrop?.classList.toggle('open',open); drawer?.setAttribute('aria-hidden',open?'false':'true'); drawerOpen?.setAttribute('aria-expanded',open?'true':'false'); document.body.classList.toggle('drawer-open',open);
      if (drawer) drawer.inert = !open;
      if (open) drawer?.querySelector('[data-k-drawer-close]')?.focus();
      else if (hadFocus) drawerOpen?.focus();
    };
    if (drawer && !drawer.classList.contains('open')) drawer.inert = true;
    drawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { setDrawer(false); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('a[href], button, input, select, [tabindex]')].filter((el) => el.tabIndex >= 0 && !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    drawerOpen?.addEventListener('click',() => setDrawer(true)); root.querySelector('[data-k-drawer-close]')?.addEventListener('click',() => setDrawer(false)); drawerBackdrop?.addEventListener('click',() => setDrawer(false)); drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click',() => setDrawer(false)));

    const localizationDialog = root.querySelector('[data-k-localization-dialog]');
    const openLocalization = () => {
      if (!(localizationDialog instanceof HTMLDialogElement)) return;
      closeMega();
      setDrawer(false);
      if (!localizationDialog.open) localizationDialog.showModal();
      const countries = [...localizationDialog.querySelectorAll('.localization-form__list-item[role="option"]:not([hidden])')];
      if (countries.length && !localizationDialog.querySelector('.country-filter__input')) {
        const current = countries.find((item) => item.getAttribute('aria-current') === 'true') || countries[0];
        countries.forEach((item) => { item.setAttribute('tabindex', item === current ? '0' : '-1'); item.setAttribute('aria-selected', item === current ? 'true' : 'false'); });
        current.focus();
      }
    };
    root.querySelectorAll('[data-k-localization-open]').forEach((trigger) => trigger.addEventListener('click', openLocalization));
    root.querySelector('[data-k-localization-close]')?.addEventListener('click', () => localizationDialog?.close());
    localizationDialog?.addEventListener('click', (event) => {
      if (event.target === localizationDialog) localizationDialog.close();
    });

    /* Draft previews POST country_code to Shopify and use an explicit country
       deep link in return_to. The market subfolder alone previously produced
       German navigation while localization.country remained GB.
       This runs only in preview; live retains native Shopify localization. */
    if (isThemePreview && localizationDialog) {
      const previewMarketRoots = {
        GB: '/',
        DE: '/de-de/',
        US: '/en-us/'
      };

      const selectPreviewCountry = (countryCode) => {
        const marketRoot = previewMarketRoots[countryCode];
        const form = localizationDialog.querySelector('form.localization-form');
        const countryInput = form?.querySelector('input[name="country_code"]');
        if (!marketRoot || !form || !countryInput) return false;

        const currentUrl = new URL(window.location.href);
        const targetUrl = new URL(marketRoot, currentUrl.origin);
        // Shopify recognizes ?country=DE/US/GB as an explicit country context
        // rather than relying on the preview's previous geolocation cookie.
        targetUrl.searchParams.set('country', countryCode);
        // Preserve the original unpublished theme preview credentials.
        for (const key of ['preview_theme_id', 'preview_key', 'preview_token']) {
          const value = currentUrl.searchParams.get(key);
          if (value) targetUrl.searchParams.set(key, value);
        }

        countryInput.value = countryCode;
        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.appendChild(returnInput);
        }
        returnInput.value = targetUrl.pathname + targetUrl.search + targetUrl.hash;

        // Do not bypass Shopify: it sets the selected country and cookie on POST.
        // The specified return_to restores this exact market and preview afterward.
        form.submit();
        return true;
      };

      // Capture before Horizon's component so only one country submission occurs.
      // Unrecognised countries continue through Shopify's standard selector.
      localizationDialog.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const option = target?.closest('.localization-form__list-item[data-value]');
        if (!option || !localizationDialog.contains(option) || !previewMarketRoots[option.dataset.value]) return;
        if (!localizationDialog.querySelector('form.localization-form input[name="country_code"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        selectPreviewCountry(option.dataset.value);
      }, true);

      // Horizon uses form.submit() for keyboard selection too, so intercept Enter
      // before its keydown handler and submit our country-aware localization form.
      localizationDialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        const target = event.target instanceof Element ? event.target : null;
        const list = target?.closest('[ref="countryList"]');
        const option = list?.querySelector('.localization-form__list-item[aria-selected="true"][data-value]');
        if (!option || !previewMarketRoots[option.dataset.value]) return;
        if (!localizationDialog.querySelector('form.localization-form input[name="country_code"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        selectPreviewCountry(option.dataset.value);
      }, true);
    }

    const openPredictiveSearch = (event) => {
      const searchModal = document.querySelector('#search-modal');
      if (typeof searchModal?.showDialog !== 'function') return;
      event.preventDefault();
      closeMega();
      setDrawer(false);
      searchModal.showDialog();
    };
    root.querySelectorAll('.k-actions a[href*="/search"], .drawer-top-action--search').forEach((trigger) => trigger.addEventListener('click', openPredictiveSearch));

    const setDrawerTab = (name) => {
      root.querySelectorAll('[data-drawer-tab]').forEach((button) => { const active = button.dataset.drawerTab === name; button.classList.toggle('active',active); button.setAttribute('aria-selected',active?'true':'false'); });
      root.querySelectorAll('[data-drawer-panel]').forEach((panel) => panel.classList.toggle('active',panel.dataset.drawerPanel === name));
    };
    root.querySelectorAll('[data-drawer-tab]').forEach((button) => button.addEventListener('click',() => setDrawerTab(button.dataset.drawerTab))); setDrawerTab('categories');

    document.addEventListener('keydown',(event) => { if (event.key === 'Escape') { closeMega(); setDrawer(false); } });
    window.addEventListener('resize',() => { if (window.innerWidth <= 760) closeMega(); else setDrawer(false); });
  });

})();
